import React, { useState } from "react";
import { Toolbar, IconButton, Badge, Typography, Box, Drawer, List, ListItem, ListItemIcon, ListItemText, useTheme, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StoreIcon from "@mui/icons-material/Store";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link, useLocation } from "react-router-dom";

import logo from "../../assets/logo-image.jpg";
import { StyledAppBar, NavigationLink, LogoContainer, DrawerContent, DRAWER_WIDTH } from "./styles";

const Navbar = ({ totalItems }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <DrawerContent>
      <List>
        <ListItem button component={Link} to="/">
          <ListItemIcon>
            <StoreIcon />
          </ListItemIcon>
          <ListItemText primary="Products" />
        </ListItem>
        <ListItem button component={Link} to="/contact/aboutus">
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary="About Us" />
        </ListItem>
        {location.pathname === "/" && (
          <ListItem button component={Link} to="/cart">
            <ListItemIcon>
              <Badge badgeContent={totalItems} color="secondary">
                <ShoppingCartIcon />
              </Badge>
            </ListItemIcon>
            <ListItemText primary="Cart" />
          </ListItem>
        )}
      </List>
    </DrawerContent>
  );
  return (
    <>
      <StyledAppBar color="inherit" position="fixed">
        <Toolbar>
          <LogoContainer component={Link} to="/">
            <img
              src={logo}
              alt="Jewelry"
              style={{
                height: "50px",
                width: "50px",
                marginRight: "10px"
              }}
            />
            <Typography
              variant={isMobile ? "h6" : "h5"}
              sx={{
                display: { xs: "none", sm: "block" }
              }}
            >
              Manuel Fridman&apos;s Jewelry Shop
            </Typography>
          </LogoContainer>

          {!isMobile ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <NavigationLink component={Link} to="/">
                <StoreIcon sx={{ mr: 1 }} />
                <Typography variant="h6" color="inherit">
                  Products
                </Typography>
              </NavigationLink>

              <NavigationLink component={Link} to="/contact/aboutus">
                <AccountCircleIcon sx={{ mr: 1 }} />
                <Typography variant="h6" color="inherit">
                  About Us
                </Typography>
              </NavigationLink>

              {location.pathname === "/" && (
                <IconButton component={Link} to="/cart" aria-label="Show cart items" color="inherit">
                  <Badge badgeContent={totalItems} color="secondary">
                    <ShoppingCartIcon />
                  </Badge>
                </IconButton>
              )}
            </Box>
          ) : (
            <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
              {location.pathname === "/" && (
                <IconButton component={Link} to="/cart" aria-label="Show cart items" color="inherit" sx={{ mr: 1 }}>
                  <Badge badgeContent={totalItems} color="secondary">
                    <ShoppingCartIcon />
                  </Badge>
                </IconButton>
              )}
              <IconButton color="inherit" aria-label="open drawer" edge="end" onClick={handleDrawerToggle}>
                <MenuIcon />
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </StyledAppBar>
      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: DRAWER_WIDTH }
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar;
